export const HeaderBouncer = () => (
  <div className="header-track relative mx-2 h-14 min-w-0 flex-1" aria-hidden="true" data-testid="header-bouncer">
    <div className="header-track-line absolute inset-x-0 bottom-1 h-[2px]" />
    <div className="header-runner absolute bottom-1 left-0">
      <div className="header-hop">
        <img src="/assets/logo-anim.png" alt="" className="header-squash h-8 w-auto drop-shadow-[0_0_8px_rgba(229,32,42,.7)]" draggable="false" />
      </div>
      <div className="header-shadow mx-auto mt-0.5 h-1 w-6 rounded-full bg-[#2563EB]/60 blur-[2px]" />
    </div>
  </div>
);
